import React from "react";
import { Container, Divider, Header } from "semantic-ui-react";
export const english_duniya = () => {
  return (
    <Container>
      <Divider hidden />
      <Header as="h1">
        <Header.Content>English Duniya</Header.Content>
        <Header.Subheader>
          <p>
            When we were building{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://plp.zaya.in/classcloud/"
              title="Checkout our cool classcloud"
            >
              Classcloud
            </a>
            , we realised a bigger problem exist in our society. Kids do not
            understand english. That's when we started{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              title="Download now!"
              href="https://play.google.com/store/apps/details?id=com.ionicframework.zayamobile694033"
            >
              English Duniya.
            </a>
            . Our design philoshopy was straight forward, kids have to learn
            english, not our app.
          </p>
          <p>Credit : Team lead and developer</p>
        </Header.Subheader>
      </Header>
      <Divider />
      <div className="iframe-container iframe-container-16by9">
        <iframe
          title="English duniya video"
          src="https://www.youtube.com/embed/1nQw8Un7cFg?enablejsapi=1"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/Projects/english_duniya.js